import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=61c8f698&scoped=true&"
import script from "./AttachmentList.vue?vue&type=script&lang=js&"
export * from "./AttachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8f698",
  null
  
)

export default component.exports